// extracted by mini-css-extract-plugin
export default {"container":"Io-z","blurb":"Jo-z","links":"Ko-z"};